import { render, staticRenderFns } from "./Sold-Items.vue?vue&type=template&id=6b787953"
import script from "./Sold-Items.vue?vue&type=script&lang=js"
export * from "./Sold-Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports